// extracted by mini-css-extract-plugin
module.exports = {"indicator_text":"LocationIndicator_indicator_text__Rgqr4"};